import api from "./apiClient";

const VID_KEY = "cehnura_vid";
const SID_KEY = "cehnura_sid";
const UTM_FIRST = "cehnura_utm_first";
const UTM_LAST = "cehnura_utm_last";
const REF_KEY = "cehnura_ref";
const UTM_FIELDS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

function uuid() {
  return (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`);
}
export function getVisitorId() {
  let v = localStorage.getItem(VID_KEY);
  if (!v) { v = uuid(); localStorage.setItem(VID_KEY, v); }
  return v;
}
function getSessionId() {
  let s = sessionStorage.getItem(SID_KEY);
  if (!s) { s = uuid(); sessionStorage.setItem(SID_KEY, s); }
  return s;
}
export function captureUtm() {
  const p = new URLSearchParams(window.location.search);
  const utm = {};
  UTM_FIELDS.forEach((k) => { if (p.get(k)) utm[k] = p.get(k); });
  if (Object.keys(utm).length) {
    if (!localStorage.getItem(UTM_FIRST)) localStorage.setItem(UTM_FIRST, JSON.stringify(utm));
    localStorage.setItem(UTM_LAST, JSON.stringify(utm));
  }
  if (p.get("ref")) localStorage.setItem(REF_KEY, p.get("ref"));
}
export function getUtm() {
  const parse = (k) => { try { return JSON.parse(localStorage.getItem(k) || "{}"); } catch { return {}; } };
  return { first: parse(UTM_FIRST), last: parse(UTM_LAST), ref: localStorage.getItem(REF_KEY) || null };
}
export async function trackEvent(name, props = {}) {
  try {
    const { last } = getUtm();
    await api.post("/funnel/event", { name, visitor_id: getVisitorId(), session_id: getSessionId(), props: { ...props, variant: getAbVariant() }, utm: last });
  } catch { /* non-bloquant */ }
}

// --- Phase L : A/B test Hero/CTA (variante stable par visiteur) ---
const AB_KEY = "cehnura_ab_hero";
export function getAbVariant() {
  let v = localStorage.getItem(AB_KEY);
  if (v !== "A" && v !== "B") {
    v = Math.random() < 0.5 ? "A" : "B";
    localStorage.setItem(AB_KEY, v);
  }
  return v;
}

// --- Phase E–G : jalons authentifiés (avec user_id côté backend) ---
export function getStoredDiagnosticId() {
  try { return (JSON.parse(sessionStorage.getItem("cehnura_diag") || "null") || {}).id || null; } catch { return null; }
}
// Rattache diagnostic + UTM + visitor_id au compte connecté (idempotent). Non-bloquant.
export async function attachFunnel() {
  try {
    const { data } = await api.post("/funnel/attach", { visitor_id: getVisitorId(), diagnostic_id: getStoredDiagnosticId() });
    return data?.funnel || null;
  } catch { return null; }
}
export async function trackAuthed(name, props = {}, once = true) {
  try { await api.post("/funnel/track", { name, visitor_id: getVisitorId(), props, once }); } catch { /* non-bloquant */ }
}
export async function fetchMyFunnel() {
  try { const { data } = await api.get("/funnel/me"); return data?.funnel || null; } catch { return null; }
}
